<template>
	<div class="uk-relative">
		<form 
			id="preferencesForm"
			method="post" 
			ref="preferencesForm"
			class="uk-form-stacked" 
			enctype="multipart/form-data"
			accept-charset="UTF-8"
			autocomplete="off"
			@submit.prevent="submitForm"
		>	
			<input type="hidden" :name="csrfName" :value="csrfToken">
			<input type="hidden" name="action" value="users/save-user">
			<input type="hidden" name="userId" :value="currentUser.id">
			<div>
				<h5>Nachtmodus</h5>
				<label class="uk-switch" for="darkTheme">
					<input type="checkbox" name="fields[darkTheme]" id="darkTheme" @click="toggleSwitch('darkTheme')" :value="darkThemeValue" ref="darkTheme">
					<div class="uk-switch-slider "></div>
				</label>
			</div>
		</form>

		<div class="overlay uk-padding" v-show="overlay">
		 <div class="uk-position-center">
			 <div class="uk-text-center">
				 <span v-show="loading"><loading-indicator></loading-indicator></span>
				 <span v-show="error" class="material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></span>
				 <span v-show="success" class="material-symbols-outlined"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg></span>
			 </div>
			 <p class="uk-text-center" v-html="message"></p>
		 </div>
		</div>
		
	</div>
</template>

<script>
import axios from 'axios';
import LoadingIndicator from './LoadingIndicator.vue'

export default {
	components: { LoadingIndicator },
	props: {
		currentUser: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			overlay: false,
			error: null,
			success: false,
			loading: false,
			message: null,
			darkThemeValue: null
		};
	},
	computed: {
		csrfName () {
			return window.csrfTokenName
		},
		csrfToken () {
			return window.csrfTokenValue
		},
	},
	mounted() {		
		var component = this;
		var darkThemeSwitch = component.$refs.darkTheme;
		
		component.$logger('app/components/preferences-form/mounted');
	
		// Update darkTheme settings
		if (component.currentUser.darkTheme) {
			darkThemeSwitch.setAttribute("checked", "checked");
			component.darkThemeValue = "1";
		} else {
			darkThemeSwitch.removeAttribute("checked");
			component.darkThemeValue= "0";
		}	
	},		
	methods: {
		toggleSwitch(ref) {

			var component = this;
			
			if(ref=='darkTheme') {
				var darkThemeSwitch = component.$refs.darkTheme;
				if(darkThemeSwitch.checked) {
					darkThemeSwitch.setAttribute("checked", "checked");
					component.darkThemeValue = "1";
				} else {
					darkThemeSwitch.removeAttribute("checked");
					component.darkThemeValue = "0";
				}
				
				component.switchDarkTheme();
			}
			
			component.submitForm();
		},
		switchDarkTheme() {
			if (document.body.classList.contains("dark")) {
				document.body.classList.remove("dark");
			} else {
				document.body.classList.add("dark");
			}			
		},
		submitForm(e) {

			var component = this;

			component.$logger('app/components/preferences-form/submit-form');
			
			// Data
			var data = {};
			
			// Form data
			var form = document.getElementById('preferencesForm');
			var formData = new FormData(form);

			// Append CSRF
			formData.append(data[window.csrfTokenName], window.csrfTokenValue);

			// Dark theme
			var darkThemeSwitch = component.$refs.darkTheme;
			if(darkThemeSwitch.checked) {
				formData.set("fields[darkTheme]", "1");
			} else {
				formData.set("fields[darkTheme]", "0");
			}

			// Toggle overly and indicator
			component.overlay = true;
			component.loading = true;

			// Request		
			axios({
				method: 'post',
				url: '/actions/users/save-user', 
				responseType: 'json',		
				data: formData,
				headers: {
					'Content-Type' : 'application/x-www-form-urlencoded',
					'Accept' : 'application/json'
				}
			})
			.then(function (response) {
								
				component.loading = false;
				
				var message = null;		
				var error = response.data.error;
				var errors = response.data.errors;
				
				if(error && typeof error != "undefined") {
					message = error;
				} else if(errors) {
					for (const item of Object.entries(errors)) {			
						if(typeof item[1][0] != "undefined") {					
							message += item[1][0] + '<br>';
						}
					}					
				}
			
				// Error
				if(error || errors) {
					
					// Update recaptcha token
					//component.setRecaptchaToken();
							
					// Update UI		
					component.loading = false;
					component.error = true;
					component.message = message;
					
					setTimeout(function() {
						component.resetMessage();
					}, 5000);
				
				// Success
				} else {
					
					component.success = true;
					component.message = "Gegevens bijgewerkt.";
	
					setTimeout(function() {
						component.resetMessage();
					}, 2000);
				
					// Reset form
					component.resetLoginName = '';			
				}
			})
			.catch(function (error) {
			
				// Json response
				var response = error.response.data;
				var errorCode = response.errorCode;
			
				component.loading = false;
				component.error = true;
				component.message = (response.message) ? response.message : "Onbekende fout, probeer het opnieuw.";
				
				//component.setRecaptchaToken();
				
				setTimeout(function() {		
					component.resetMessage();
				}, 4000);	
			});

		},
		resetMessage: function() {
			
			var component = this;
			
			component.message = null;
			component.error = false;
			component.overlay = false;
			component.loading = false;		
		}
	},
};
</script>


<style>
.overlay {
	position: absolute; top: 0; height: 100%; width: 100%; z-index: 999; background-color: rgba(255, 255, 255, 0.9); 
}
</style>
